/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Purchase {

    import fld = PurchaseReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnItemsEditor extends _Ext.ItemGridEditor<PurchaseReturnItemsRow> {

        protected getColumnsKey() { return "Purchase.PurchaseReturnItems"; }
        protected getDialogType() { return PurchaseReturnItemsDialog; }
        protected getLocalTextPrefix() { return PurchaseReturnItemsRow.localTextPrefix; }
        protected form: PurchaseReturnItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public TotalItems: number;
        //For RM Setup
        public ProductTypeId: number;
        statement: string;  

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }

        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            PurchaseReturnMasterDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.canUpdate == 0) {
                        Q.alert("Voucher is ReadOnly can not Delete!!")
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        Q.confirm('Are you sure want to Delete? ', () => {

                            var id = this.id(item);
                            let refid: any;
                            TabAurous.Stock.StockItemService.CheckItemTransaction(
                                {
                                    RefTransId: item.TransId,
                                    RefTransItemId: item.TransItemId,
                                    Line_No: (item.Line_No),
                                    ProductId: (item.ProductId)
                                }
                                , response => {
                                    refid = response.Entities
                                }, { async: false })
                            if (refid != null && refid.length > 0) {
                                if (refid[0].TransId != null || refid[0].TransId > 0) {
                                    Q.alert("This Item has been used in transactions Can Not Delete!");
                                    return;
                                }
                            }else {

                                this.TotalItems = this.view.getItems().length - 1;
                                this.view.deleteItem(id);
                                this.element.trigger('dialogclose');

                            }
                        });
                    }
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                this.canUpdate = this.readOnly ? 0 : 1;
                var input = $(e.target);
                if (input != undefined) {
                    if (this.canUpdate == 0) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        Q.alert("Voucher is ReadOnly can not Edit!!")

                    }
                    else if (this.canUpdate == 1) {
                        target.removeClass('readonly');
                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "UnitRate" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }

                }

                this.view.refresh();
            }

        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject, ) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }



            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }

                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }

        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            var grid = Purchase.PurchaseItemsSelectGrid;

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "stock-button",
                hotkey: "alt+k",
                onClick: () => {

                    // **** Validate Party before Item Selection ****d
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.TransItemId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.TransItemId == t.TransItemId) });
                        var ItemDetails = ItemGridHelper.SetReturnItemGrid(selectedItems2);

                        if (this.view.getItems().length > 0) {
                            this.TotalItems = ItemDetails.length + this.view.getItems().length;
                        }
                        else {
                            this.TotalItems = ItemDetails.length;
                        }
                        for (let Item of ItemDetails) {
                            Item[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Item;
                            this.view.addItem(Item);
                        }
                    }
                     
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion

        getItemData(items) {
            let x;
            for (let rateitem of items) {
                rateitem[this.getIdProperty()] = "`" + this.nextId++;
                x.push(rateitem);
            }
            return x;
        }

    }
}